import React from "react";
import { Modal } from "react-bootstrap";

const PreviewModal = ({ show, onHide, fileUrl, fileName }) => {
  const isPDF = fileName?.endsWith(".pdf");
console.log(fileUrl, isPDF,fileName, "fileUrl");

  return (
    <Modal show={show} onHide={onHide} size="lg" centered
    className="ifscModal preview-modal">
      <Modal.Header>
      <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        {/* <Modal.Title>{fileName || "Document Preview"}</Modal.Title> */}
      </Modal.Header>
      <Modal.Body>
      <form className="modal-form select-new">
            <div className="form-group">
        {isPDF ? (
          <iframe
            src={fileUrl}
            width="100%"
            height="500px"
            title="Preview PDF"
            frameBorder="0"
          />
        ) : (
          <img
            src={fileUrl}
            alt="Preview"
            style={{ width: "100%", height: "auto" }}
          />
        )}
        </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default PreviewModal;